"use client";

import { useSyncExternalStore } from "react";
const subscribeNever = () => () => {};

/**
 * True only once the client has hydrated; false during SSR. Using
 * useSyncExternalStore (instead of a useEffect + setState) keeps the
 * server/first-client render identical, avoiding a hydration mismatch,
 * without the cascading-render setState-in-effect happening.
 */
export function useIsHydrated() {
  return useSyncExternalStore(subscribeNever, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}